import "../index.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { PageNav } from "../components/PageNav";

interface BookshelfDoc {
  title: string;
  author: string;
  description: string;
  href: string;
}

const documents: BookshelfDoc[] = [
  {
    title: "Leadership Culture Maturity",
    author: "Brian A. Armstrong, Ph.D.",
    description:
      "Armstrong's original research into leadership culture, based upon the 12 stages of the Hero's Journey, offers a unique approach to both diagnose leadership practices within an organization as well as identify development opportunities.",
    href: "/documents/leadership-culture-maturity-dissertation.pdf",
  },
];

function DocumentIcon() {
  return (
    <svg viewBox="0 0 56 56" width="56" height="56">
      <rect
        x="12"
        y="6"
        width="32"
        height="44"
        rx="4"
        fill="rgba(59, 130, 246, 0.14)"
        stroke="#3b82f6"
        strokeWidth="2"
      />
      <line x1="19" y1="18" x2="37" y2="18" stroke="#3b82f6" strokeWidth="2" />
      <line x1="19" y1="26" x2="37" y2="26" stroke="#3b82f6" strokeWidth="2" />
      <line x1="19" y1="34" x2="31" y2="34" stroke="#3b82f6" strokeWidth="2" />
    </svg>
  );
}

export default function Bookshelf() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageNav />
      <div className="bsp-page">
        <div className="bsp-section bsp-container-narrow font_family_base">
          <div className="bsp-eyebrow bsp-center">The Bookshelf</div>
          <h1 className="bsp-h1 bsp-center">Additional Reading</h1>
          <p className="bsp-lead bsp-center" style={{ marginBottom: 40 }}>
            Research, writing, and resources behind the BStrong approach to
            leadership.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {documents.map((doc) => (
              <div
                key={doc.title}
                className="bsp-card"
                style={{ display: "flex", gap: 20, alignItems: "flex-start" }}
              >
                <div style={{ flexShrink: 0 }}>
                  <DocumentIcon />
                </div>
                <div style={{ flex: 1 }}>
                  <h3 className="bsp-h3">{doc.title}</h3>
                  <div
                    className="bsp-eyebrow"
                    style={{ marginBottom: 12, textTransform: "none", letterSpacing: 0 }}
                  >
                    {doc.author}
                  </div>
                  <p className="bsp-body" style={{ marginBottom: 20 }}>
                    {doc.description}
                  </p>
                  <a
                    href={doc.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bsp-btn bsp-btn-outline"
                  >
                    Read the Dissertation
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bsp-section bsp-cta-band bsp-center">
          <h2 className="bsp-h2 font_family_base">More on the Way</h2>
          <p className="bsp-lead font_family_base" style={{ marginBottom: 8 }}>
            Brian's forthcoming book, <em>The BStrong Leadership Framework</em>,
            will be added here as it becomes available.
          </p>
          <div className="bsp-hero-actions">
            <Link to="/about" className="bsp-btn bsp-btn-outline font_family_base">
              About BStrong
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
